const TEST_DEFAULTS: Record<string, string> = {
  VITE_API_BASE_URL: '',
  VITE_ENV: 'development',
};

function requireEnv(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (value !== undefined && value !== null) return value;

  // In test mode (Vitest), env vars may not be loaded — use sensible defaults
  if (import.meta.env.MODE === 'test' && key in TEST_DEFAULTS) {
    return TEST_DEFAULTS[key];
  }

  throw new Error(`Missing required environment variable: ${key}`);
}

/**
 * Read an optional env var, returning fallback when absent.
 * Used for VITE_API_BASE_URL which can be empty (= same-origin proxy).
 */
function optionalEnv(key: string, fallback: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (value !== undefined && value !== null) return value;

  if (import.meta.env.MODE === 'test' && key in TEST_DEFAULTS) {
    return TEST_DEFAULTS[key];
  }

  return fallback;
}

export const env = {
  apiBaseUrl: optionalEnv('VITE_API_BASE_URL', ''),
  apiTimeoutMs: Number(import.meta.env.VITE_API_TIMEOUT_MS ?? 30000),
  env: (requireEnv('VITE_ENV')) as 'development' | 'staging' | 'production',
  enableMockApi: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
} as const;

export type Env = typeof env;
